import React from "react";
import {Link} from "react-router";

import Chart from "./UI/Chart/Chart";

import {api, parsePHPtime} from "./baseFunctions";
import langs from "./langs/phpIndex";

import ChartMaker from "./UI/ChartMaker/ChartMaker";


import "./css/print.css";
import "./css/weeklyReport.css";

export default class PrintPage extends React.Component {
	constructor(){
		super();
		this.state = {
			panels: false,
		};
	}

	componentDidMount(){
		if([...document.body.classList].indexOf("inReport") === -1)
		{
			document.body.classList.toggle("inReport");
		}

		api("POST", {"type": "getPanels", page: "dashboard"}, (d) => {
			if(!d.error)
			{
				let panels = [
					/*{type: "OBS_LOCAL_KPI"},
					{
						type: "OBS_LOCAL_MONTH_KPI",
					},*/
					...d.data,
					
				];
				this.setState({panels});
				//this.drawGenerel(this.refs.general);
			}
		}, this.props.auth, 1);
	}

	componentWillUnmount(){
		document.body.classList.toggle("inReport");
	}

	render(){
		if(!this.state.panels)
		{
			return null;
		}
		return (
			<ChartMaker types={[this.props.params.type]} typeData={[{type: this.props.params.type}]} 
				interval={{from: this.props.params.from, to: this.props.params.to}} 
				auth={this.props.auth}
				lang={this.props.lang}
				typeData={this.state.panels}
				className="chart-container"
				hidePanels={true}
				onReady={() => setTimeout(() => {
					window.print();

					//requestAnimationFrame(() => window.close());
				}, 500)}

			/>);
	}
}


// WEBPACK FOOTER //
// ./src/components/PrintPage.js